import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

export const postUserSatisfaction = async (body) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .post(`${BASE_URL}user-satisfactions`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postUser', error.response.data)
      return error
    })
}

export const getUserStatisfactionByOrigin = async (originName) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))
  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }
  try {
    const userSatisfation = await axios.get(
      `${BASE_URL}/user-satisfactions/origin/${originName}`, config,
    )
    return userSatisfation;
  } catch (error) {
    console.log('error on user-satisfacion request', error)
    return error
  }
};